import { Column } from "../interfaces/models/Column.model";

export const pillarColumns = [
    {
        field: 'name',
        header: 'الاسم',
    },
    {
        field: 'description',
        header: 'الوصف',
    },
    {
        field: 'char',
        header: 'الرمز',
    },
    {
        field: 'color',
        header: 'اللون',
    }
] as Column[];
export const goalColumns = [
    {
        field: 'name',
        header: 'اسم الهدف',
    },
    {
        field: 'pillar_name',
        header: 'اسم المحور',
    },
    {
        field: 'code',
        header: 'الرمز',
    }
] as Column[];
export const valueColumns = [
    {
        field: 'name',
        header: 'الاسم',
    },
    {
        field: 'icon',
        header: 'الأيقونة',
    },

] as Column[];
export const indicatorResultColumns = [
    {
        field: 'cycle',
        header: 'اسم دورة القياس',
    },
    {
        field: 'target',
        header: 'المستهدف',
    },
    {
        field: 'actual',
        header: 'المحقق',
    },
    {
        field: 'notes',
        header: 'ملاحظات',
    },
    // {
    //     field: 'is_positive',
    //     header: 'إيجابية أم سلبية',
    // },
] as Column[];


